<template>
  <bounce-loader v-if="checkIfIsBecomeDomain()" />
  <pulse-loader v-else-if="isLoaderV1" />
  <pulse-loader-v2 v-else />
</template>

<script>
import PulseLoaderV2 from '@ui-kit/components/loaders/PulseLoaderV2.vue';
import PulseLoader from '@ui-kit/components/loaders/PulseLoader.vue';
import BounceLoader from '@/components/loaders/BounceLoader.vue';
import config from '@/config';
import checkIfIsBecomeDomain from '@/scripts/checkIfIsBecomeDomain';

export default {
  name: 'UnitLoader',
  components: { PulseLoader, PulseLoaderV2, BounceLoader },
  computed: {
    isLoaderV1() {
      return config.isBloom;
    },
  },
  methods: {
    checkIfIsBecomeDomain,
  },
};
</script>
